import React from 'react'
import classNames from 'classnames'
import { brandColors } from 'front-end/../shared/basicPalette'
import { Box, LinkBox, Text } from 'front-end/src/components'

import { BoxProps } from '@chakra-ui/react'

import UserAvatar from '../user-avatar/UserAvatar'

import './UserDetail.less'

const UserDetail = ({
  display_name,
  className,
  imageUrl,
  image_url,
  meta,
  size = 'normal',
  onClick,
  ...rest
}: BoxProps & {
  display_name?: string | null
  className?: string
  imageUrl?: string | null
  image_url?: string | null
  meta?: string
  onClick?: (ev: React.MouseEvent<HTMLDivElement>) => void
  size?: 'small' | 'normal'
}) => {
  return (
    <LinkBox
      onClick={onClick}
      className={classNames('UserDetail', size, className, {
        clickable: !!onClick
      })}
      {...rest}
    >
      <UserAvatar
        user={{
          display_name: display_name,
          image_url: (imageUrl || image_url) as string
        }}
        size={size}
      />
      <Box className="UserDetail__details">
        <Text
          className="UserDetail__name"
          fontWeight="500"
          noOfLines={2}
          color={brandColors.grey[800]}
          title={display_name || ''}
        >
          {display_name}
        </Text>
        {meta && (
          <Box as="span" className="UserDetail__meta">
            {meta}
          </Box>
        )}
      </Box>
    </LinkBox>
  )
}

export default UserDetail
